export const CHILD_ROUTE = {
    FIND_TENANTS: 'find-tenants',
    MANAGE_TENANTS: 'manage-tenants',
};
